var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOnMaintenance)?_c('v-app',[_c('OnMaintenance',{attrs:{"seconds":31}})],1):_c('v-app',[_c('FeedbackProgress'),_c('FeedbackDialog'),_c('FeedbackSnack'),_c('BetDialog'),_c('VariableCommission'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }